import { useEffect, useState } from 'react'

/** Current time, refreshed every `everyMs` (relative times like "há 3 min" stay right without new data). */
export function useNow(everyMs = 30_000): Date {
    const [now, setNow] = useState(() => new Date())
    useEffect(() => {
        const id = window.setInterval(() => setNow(new Date()), everyMs)
        return () => window.clearInterval(id)
    }, [everyMs])
    return now
}
